// @flow

//
// React
//
import React, { type Node } from 'react';

//
// Trix Middleware
//
import { get as httpGet } from '../../../../lib/trix-web-middleware-commons';

//
// Trix Data
//
import {
    hasErrorCausesForLocation,
    formatErrorsForLocation,
} from '../../../../lib/trix-web-data-commons';

//
// Trix Data Commons
//
import { buildUrl } from '../../../../lib/trix-web-data-commons';

//
// Components
//
import {
    ComboBoxFormPaneField,
    type FormPaneContentProps,
} from '../../../../lib/trix-web-components-pane';

export const getFindUrl = (params: any) => {
    return buildUrl(
        '/api/v1/wms/pricelist/pricedItems/search/byFreeText?text={text}&page={page}&size={size}',
        params
    );
};

//
// Props
//
type Props = {
    name: string,
    label: string,
    description: string,
    helperText: string,
    disabled: boolean;

    value: any,
    error: any,

    onChange: (data: any) => void,
}

//
// Component
//
const Content = (props: Props): Node => {
    //
    // Hooks
    //
    // End hooks

    return (
        <ComboBoxFormPaneField
            label={props.label}
            description={props.description}
            disabled={props.disabled}

            value={props.value}
            error={props.error}

            onChange={props.onChange}

            onLoadData={(value, reject, resolve) =>
                httpGet(
                    // url
                    getFindUrl({
                        // filter param
                        text: value,
                        
                        // paging
                        page: 0,
                        size: 20,
                    }),

                    // options
                    null,

                    // reject callback
                    reject,

                    // resolve callback
                    (data) =>
                        resolve(
                            (data && data.body && data.body._embedded && data.body._embedded.pricedItems) ? 
                                    data.body._embedded.pricedItems : []
                        )
                )
            }
            onGetOptionLabel={(option) => (option) ? 
                    `${option.code}, ${option.name.bg}` : ''}
            isOptionEqualToValue={(option, value) => {
                return option.code === value.code;
            }}
            
            dataPath={props.name}
        />
    );
};
export default Content;
